import {
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import {
  provideHttpClient,
  withInterceptors,
  withInterceptorsFromDi,
  HTTP_INTERCEPTORS,
} from '@angular/common/http';
import { provideAuth0, AuthHttpInterceptor } from '@auth0/auth0-angular';
import { appRoutes } from './app.routes';
import { authExpiryInterceptor } from './core/auth/auth-expiry.interceptor';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import { MessageService } from 'primeng/api';
import Aura from '@primeng/themes/aura';
import { environment } from '../environments/environment';
import {
  ORG_CONTEXT_CONFIG,
  PIPELINE_TEMPLATE_SERVICE_CONFIG,
  TEAM_SERVICE_CONFIG,
} from '@org/shared';
import { CV_UPLOAD_CONFIG } from '@org/cv-upload';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideAuth0({
      domain: environment.auth0.domain,
      clientId: environment.auth0.clientId,
      cacheLocation: 'localstorage',
      // organization is NOT set here — it must be the org_id (org_xxx format), not a slug.
      // The custom AuthGuard resolves the org_id asynchronously before calling loginWithRedirect.
      authorizationParams: environment.auth0.authorizationParams,
      httpInterceptor: environment.httpInterceptor,
    }),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthHttpInterceptor,
      multi: true,
    },
    provideHttpClient(
      withInterceptorsFromDi(),
      withInterceptors([authExpiryInterceptor]),
    ),
    provideRouter(appRoutes),
    provideAnimationsAsync(),
    {
      provide: ORG_CONTEXT_CONFIG,
      useValue: { apiUrl: environment.apiUrl, baseDomain: environment.baseDomain },
    },
    {
      // The shared cv-upload lib is app-agnostic; the app supplies the
      // recruitment API base URL from its own environment file here.
      provide: CV_UPLOAD_CONFIG,
      useValue: { recruitmentApiUrl: `${environment.apiUrl}/api/recruitment` },
    },
    {
      // The shared TeamService is app-agnostic; app maps its own
      // environment to the tenant-management API base URL here.
      provide: TEAM_SERVICE_CONFIG,
      useValue: { tenantApiUrl: `${environment.apiUrl}/api/tenant` },
    },
    {
      // Pipeline templates live under the recruitment API alongside jobs.
      provide: PIPELINE_TEMPLATE_SERVICE_CONFIG,
      useValue: { recruitmentApiUrl: `${environment.apiUrl}/api/recruitment` },
    },
    MessageService,
    providePrimeNG({
      theme: {
        preset: Aura,
        options: {
          darkModeSelector: '.dark-mode',
        },
      },
    }),
  ],
};
